module.exports = __webpack_public_path__ + "static/media/bookmark_img.f521f038.png";